export enum BookviewSearchScope {
    CurrentView,
    EntirePublication,
}
